import React from 'react';
import { RouteTabs, FixedTab } from '../../components/RouteTabs';
import Comment from './Comment/Comment';
import DisplayName from './DisplayName/DisplayName';
import ProfileImage from './ProfileImage/ProfileImage';

interface IProps {
  path: string;
  isShownReportedOnly: boolean;
}

const Main = (props: IProps): JSX.Element => {
  const { path } = props;

  return (
    <RouteTabs isNested={true} path={path}>
      <FixedTab label="Comments">
        <Comment isBannedUserMode={false} isShownReportedOnly={props.isShownReportedOnly} />
      </FixedTab>
      <FixedTab label="Profile Images" uri={`profile-images`}>
        <ProfileImage isShownReportedOnly={props.isShownReportedOnly} />
      </FixedTab>
      <FixedTab label="Display name" uri={`display-names`}>
        <DisplayName isShownReportedOnly={props.isShownReportedOnly} />
      </FixedTab>
    </RouteTabs>
  );
};

export default React.memo(Main);
